import { useRouter } from 'next/router'
import TagManager from 'react-gtm-module'
import { useContext, useMemo } from 'react'
import { useTranslation } from 'next-i18next'
import { LandingSearchTextType } from 'tsconfig/craft-types'
import { MDropdown, MDropdownOption } from '../molecules/m-dropdown'
import { MSearchInput } from '../molecules/m-search-input'
import useSettings from '../../hooks/use-settings'
import { AppContext, AppContextType } from '../../context/app'
import { CraftRegion } from '../../craft-types'

type Props = {
  landingDoctorFinder?: LandingSearchTextType[]
}

export const CSearchBar = ({ landingDoctorFinder }: Props) => {
  const settings = useSettings()
  const router = useRouter()

  const { t } = useTranslation('common')
  const appContext = useContext(AppContext) as AppContextType
  const isDoctorEvent =
    appContext.state.query.type === 'doctors' ||
    appContext.state.query.type === ''
  const isLocationEVent = appContext.state.query.type === 'locations'

  console.log({
    isDoctorEvent,
    isLocationEVent,
  })

  const doctorSearchEvent = (value: string) => {
    TagManager.dataLayer({
      dataLayer: {
        event: 'doctorSearch',
        event_category: 'Doctor Search',
        event_action: 'List component on search results page',
        event_label: value,
      },
    })
  }

  const locationSearchEvent = (value: string) => {
    TagManager.dataLayer({
      dataLayer: {
        event: 'locationSearch',
        event_category: 'Location Search',
        event_action: 'List component on search results page',
        event_label: value,
      },
    })
  }

  const handleRegionChange = (option: MDropdownOption) => {
    const isSpainRegionDropdown =
      router.locale === 'es-ES' && settings.search === 'regions'

    const currentType =
      appContext.state.query.type ||
      (typeof router.query.type === 'string' ? router.query.type : '')

    const targetType = isSpainRegionDropdown
      ? 'locations'
      : currentType || 'doctors'

    const query = {
      ...router.query,
      q: option.value,
      type: targetType,
    }

    const queryParams = new URLSearchParams(query as Record<string, string>).toString()
    router.push(`/?${queryParams}`, undefined, { shallow: true })

    if (targetType === 'doctors') {
      doctorSearchEvent(option.value)
    }

    if (targetType === 'locations') {
      locationSearchEvent(option.value)
    }
  }

  const handleSubmitSearch = (value: string) => {
    if (isDoctorEvent) {
      doctorSearchEvent(value)
    }

    if (isLocationEVent) {
      locationSearchEvent(value)
    }

    const query = {
      ...router.query,
      q: value,
    }

    const queryParams = new URLSearchParams(query).toString()
    router.push(`/?${queryParams}`, undefined, { shallow: true })
  }

  const regionsOptions: Array<MDropdownOption> = useMemo(() => {
    return appContext.state.regions.map((region: CraftRegion) => {
      return {
        option: region.title ?? '',
        value: region.slug ?? '',
        selected: appContext.state.query.q === region.slug,
      }
    })
  }, [appContext.state.query.q, appContext.state.regions])

  return (
    <div>
      {settings.search === 'regions' && (
        <MDropdown
          label={t('region')}
          full={true}
          placeholder={t('select-a-region') ?? ''}
          options={regionsOptions}
          onChange={handleRegionChange}
        />
      )}
      {settings.search !== 'regions' && (
        <MSearchInput
          onSubmit={handleSubmitSearch}
          landingSearchText={landingDoctorFinder?.[0]}
        />
      )}
    </div>
  )
}
